import moment from "moment";

const initialState = () => ({
	activeWasteType: "avoidable",
	wasteTypes: [
		"avoidable",
		"unavoidable",
		"all"
	],

	activePeriod: "month",
	periods: [
		"day",
		"week",
		"month",
		"year"
	],

	activeCompareTo: "previous_month",
	activeDate: null,
});

export default {
	namespaced: true,

	state: initialState(),

	mutations: {
		setActiveWasteType,

		// setting period has side effects, use the selectPeriod action
		_setActivePeriod,
		setActiveDate,
		setActiveCompareTo,
		resetState
	},

	actions: {selectPeriod},

	getters: {
		activeWasteType: state => state.activeWasteType,
		wasteTypes: state => state.wasteTypes,

		periods: state => state.periods,
		activePeriod: state => state.activePeriod,

		activeDate: state => moment(state.activeDate),

		/**
		 * @returns {number|string}
		 * If it a number that means that a year is currently selected
		 * if it is a string that means that day, week or month is the activePeriod
		 */
		activeCompareTo: state => state.activeCompareTo,
		activeCompareToTranslation: state => {
			if (typeof state.activeCompareTo === "number")
				return state.activeCompareTo;

			return `filters_compare_${state.activePeriod}.${state.activeCompareTo}`;
		},
		compareToByPeriod: (state, getters, rootState, rootGetters) => {
			const activeOutlet = rootGetters["user/activeOutlet"],

				/** @type {number[]} */
				years = getValidCompareToYears(activeOutlet, getters.activeDate);

			/*
			 * Note that only the year is an array of number,
			 * day, week, month is an array of string
			 */
			return {
				day: [
					"day_before",
					"same_day_week_before",
					"average_day",
					"base_day"
				],
				week: [
					"previous_week",
					"average_week",
					"base_week"
				],
				month: [
					"previous_month",
					"average_month",
					"base_month"
				],
				year: years
			};
		},
		compareToDropdownItems: (state, getters, rootState, rootGetters) => {
			let dropdownItems = getters.compareToByPeriod[state.activePeriod];

			const hasBaseLine = Boolean(rootGetters["user/activeOutlet"].baseline);
			if (!hasBaseLine && state.activePeriod !== "year") {
				// remove base filters if outlet don't have a baseline
				dropdownItems = dropdownItems.filter(compareTo => !compareTo.includes("base_"));
			}

			return dropdownItems;
		}
	}
};

function resetState(state) {
	Object.assign(state, initialState());
}

function setActiveWasteType(state, wasteType) {
	state.activeWasteType = wasteType;
}

function selectPeriod({ commit, getters }, period) {
	const compareTo = getters.compareToByPeriod[period][0];
	commit("_setActivePeriod", period);
	commit("setActiveCompareTo", compareTo);
}

function _setActivePeriod(state, period) {
	state.activePeriod = period;
}

function setActiveDate(state, date) {
	state.activeDate = moment(date).format("YYYY-MM-DD");
}

function setActiveCompareTo(state, compareTo) {
	state.activeCompareTo = compareTo;
}

function getValidCompareToYears(activeOutlet, activeDate) {
	// use outlet start date for minimum "compare to" year
	const minYear = moment(activeOutlet.outlet_start_date).year(),

		/*
		 * use selected "activeDate" as the maximum "compare to" year
		 * or fall-back to "outlet_data_validity" if "activeDate" is not available
		 */
		maxYear = moment(activeDate).year() || moment(activeOutlet.outlet_data_validity).year(),
		years = [];

	// generate valid years for compare to labels
	for (let year = minYear; year < maxYear; year++)
		years.push(year);


	return years;
}
